var render = function render(){var _vm=this,_c=_vm._self._c;return _c('error-content',{attrs:{"code":"500","desc":"服务器繁忙， 请稍后再试","src":_vm.src}})
}
var staticRenderFns = []

export { render, staticRenderFns }